module.exports = __webpack_public_path__ + "img/spinner-primary.ec39e373.svg";